import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';

function selectRadius({
  theme
}) {
  return theme.form.input.radius;
}
const Suffix = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30037988__sc-1rtz4en-0"
})(["flex:0 0 auto;box-sizing:border-box;white-space:nowrap;display:flex;align-items:center;padding-inline-start:", ";padding-inline-end:calc(", " - 2px);min-height:calc(", " - 6px);background:", ";font-size:", ";color:", ";line-height:1.465;/*! @noflip */ border-radius:0 ", " ", " 0;", " ", " ", ""], ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.form.input.height, ({
  theme
}) => theme.form.input.affix.bg, ({
  theme
}) => theme.form.input.affix.fontSize, ({
  theme
}) => theme.form.input.affix.color, selectRadius, selectRadius, ({
  $ignoreTextDirection
}) => !$ignoreTextDirection && css(["/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ border-radius:", " 0 0 ", ";}"], selectRadius, selectRadius), ({
  disabled,
  theme
}) => disabled && css(["cursor:not-allowed;outline:none;opacity:1;border-color:", ";background:", ";color:", ";"], theme.form.input.disabled.borderColor, theme.form.input.disabled.bg, theme.form.input.disabled.color), isMobile(css(["padding-inline-start:", ";padding-inline-end:calc(", " - 2px);font-size:", ";"], ({
  theme
}) => theme.mobile.spacing.mini, ({
  theme
}) => theme.mobile.spacing.mini, ({
  theme
}) => theme.form.input.mobile.affix.fontSize)));
Suffix.displayName = 'Suffix';
var Suffix$1 = Suffix;

export { Suffix$1 as S };
//# sourceMappingURL=Suffix-2a24889c.js.map
